import { render, staticRenderFns } from "./UploadFileeForm.vue?vue&type=template&id=4a56e0f2"
import script from "./UploadFileeForm.vue?vue&type=script&lang=js"
export * from "./UploadFileeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports